import React, { useState } from 'react';
import styled from 'styled-components';

import { colors } from '../styles/colors';
import Icon from './Icon';
import Button from './Button';
import AirportNameAndFlightTime from './AirportNameAndFlightTime';
import FlightNameAndType from './FlightNameAndType';
import Moment from 'react-moment';
import 'moment/locale/pt-br';

const Container = styled.div`
  cursor: pointer;
  border: 1px solid ${colors.GRAY};
  border-radius: 4px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
`;

const ButtonCheckBoxContainer = styled(Button)`
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: none;
  height: 24px;
  width: 24px;
  padding: 0;
  margin-bottom: 0;
  margin-right: 12px;

  ${({ value }) => `
    border: 1px solid ${value ? 'white' : colors.GRAY_DARKEST};
    background-color: ${value ? colors.SUCCESS : 'white'};
  `}
`;

const ToggleFieldContainer = styled.div`
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  user-select: none;
  align-items: center;
  justify-content: center;

  &:focus {
    outline: none;
  }
`;

const DateLabel = styled.span`
  font-size: 14px;
  color: ${colors.GRAY_DARKEST};
  ${({ value }) =>
    value
      ? `
        margin-top: 4px;
        font-weight: bold;
      `
      : ''}
`;

const CheckIcon = styled(Icon)`
  color: ${colors.GRAY};
  font-size: 24px;
  color: white;
`;

const CheckboxContainer = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  border-bottom: 1px solid ${colors.GRAY};
`;

const FlightInfoContainer = styled.div`
  color: ${colors.GRAY_DARKEST};
  padding: 12px;
  display: flex;
`;

const AirportNameAndFLightTimesContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

const AirplaneIcon = styled(Icon)`
  font-size: 16px;
  margin-right: 10px;
  margin-left: 10px;
`;

export default function FlightCheckbox({
  value,
  enableLabelMultiline,
  containered,
  option,
  tabIndex,
  setLabelMinHeight,
  disabled,
  field,
  validationMinHeight,
  form,
  format,
  onChange,
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false);

  const toggleField = () => {
    if (!disabled) {
      if (option) {
        const checkValue = field.value ? undefined : option;
        form.clearForm();
        form.setFieldValue(field.name, checkValue);

        onChange(checkValue);
      } else {
        form.resetForm();
        form.setFieldValue(field.name, value);
        onChange(field.value);
      }
    }
  };

  if (!value) return <p>Carregando dados do voo</p>;

  return (
    <Container
      onClick={e => {
        toggleField(e);
      }}
      {...props}
    >
      <CheckboxContainer>
        <ButtonCheckBoxContainer
          type="button"
          containered={containered}
          enableLabelMultiline={enableLabelMultiline}
          isFocused={isFocused}
          tabIndex={tabIndex}
          onKeyPress={e => {
            if (e.key.toLowerCase() === 'enter') {
              toggleField(e);
            }
          }}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            form.setFieldTouched(field.name, true, true);
            setIsFocused(false);
          }}
          value={form.values[field.name] === value}
        >
          <ToggleFieldContainer name={field.name}>
            {form.values[field.name] === value ? (
              <CheckIcon name="keyboard-arrow-down" />
            ) : null}
          </ToggleFieldContainer>
        </ButtonCheckBoxContainer>
        <DateLabel value={form.values[field.name] === value}>
          <Moment format="dddd">{value.std}</Moment>
          <span>, </span>
          <Moment format="DD/MM/YYYY">{value.std}</Moment>
        </DateLabel>
      </CheckboxContainer>
      <FlightInfoContainer>
        <AirportNameAndFLightTimesContainer>
          <AirportNameAndFlightTime
            airportName={value.departureStation}
            flightTime={<Moment format="HH:mm">{value.std}</Moment>}
          />
          <AirplaneIcon name="plane-horizontal" />
          <AirportNameAndFlightTime
            airportName={value.arrivalStation}
            flightTime={<Moment format="HH:mm">{value.sta}</Moment>}
          />
        </AirportNameAndFLightTimesContainer>
        <FlightNameAndType
          flightName={`${value.carrierCode} ${value.flightNumber}`}
          flightType={value.flightInformation}
        />
      </FlightInfoContainer>
    </Container>
  );
}
